(() => {
  const settingsNode = document.querySelector('#SBCrossStoreCheckout');
  if (!settingsNode) return;
  const settings = JSON.parse(settingsNode.textContent);
  const key = 'sb-store-b-cart-v1';
  const ui = text => window.SBUI ? window.SBUI(text) : text;
  const error = text => { throw new Error(ui(text)); };
  let configuration, inventory, loading;
  const request = async (url, options = {}) => {
    const response = await fetch(url, { ...options, credentials: 'omit', referrerPolicy: 'no-referrer', signal: AbortSignal.timeout(20000) });
    if (!response.ok) error('The package connection could not be loaded. Please try again.');
    return response.json();
  };
  const config = async () => {
    if (!configuration) {
      const value = await request(settings.mappingUrl, { cache: 'no-store' });
      if (value.version !== 3 || !/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(value.store_b_domain) || value.store_b_domain === settings.sourceDomain) error('The service connection is unavailable.');
      configuration = value;
    }
    return configuration;
  };
  const refresh = async () => {
    if (loading) return loading;
    loading = (async () => {
      const c = await config(), next = new Map();
      for (const entry of [...Object.values(c.products), ...Object.values(c.addons)]) {
        const price = Math.round(Number(entry.reference_unit_price_eur) * 100);
        if (entry.store_b_variant_id && Number.isSafeInteger(price) && price >= 0) next.set(entry.store_b_variant_id, price);
      }
      inventory = next;
    })();
    try { await loading; } finally { loading = null; }
  };
  const quote = id => {
    const rule = window.SBCheckoutSourceRules?.[String(id)];
    const productPart = rule?.components?.find(c => c.section === 'products');
    const servicePaused = configuration?.paused_product_handles?.includes(productPart?.key.split('--')[0]) === true;
    const result = { available: Boolean(inventory && rule?.components?.length) && !servicePaused, price: 0, media: 0, components: [] };
    for (const part of rule?.components || []) {
      const destination = configuration?.[part.section]?.[part.key]?.store_b_variant_id;
      const v = inventory?.get(destination);
      const price = v * part.quantity_multiplier;
      if (!Number.isSafeInteger(price) || price < 0) result.available = false;
      if (Number.isSafeInteger(price)) result.price += price;
      if (part.key === 'image' || part.key === 'video') result.media += price || 0;
      result.components.push({ merchandiseId: `gid://shopify/ProductVariant/${destination}`, quantity: part.quantity_multiplier });
    }
    if (rule?.legacyCostRule) {
      const r = rule.legacyCostRule;
      result.price = window.SBCustomCost.quoteCost(r.unitCostCents, r.units, r.feeBasisPoints).total;
    }
    result.original_price = result.price;
    const count = Number(rule?.options?.Quantity);
    if (count > 1 && productPart) {
      const prefix = productPart.key.split('--')[0];
      const unit = Object.entries(window.SBCheckoutSourceRules).find(([, r]) => r.options?.Quantity === '1' && r.components.some(c => c.section === 'products' && c.key.split('--')[0] === prefix) && Object.entries(rule.options).every(([key, value]) => key === 'Quantity' || r.options[key] === value));
      if (unit) result.original_price = Math.max(result.price, quote(unit[0]).price * count);
    }
    return result;
  };
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '{"items":[],"revision":0}');
      if (!Array.isArray(value.items) || value.items.length > 250) throw new Error();
      return value;
    } catch (_) { error('Your cart could not be loaded. Please enable browser storage and try again.'); }
  };
  const signature = cart => JSON.stringify(cart.items.map(i => [i.key, i.variant_id, i.quantity, i.properties]));
  const matches = cart => Boolean(cart?.items && signature(read()) === signature(cart));
  const assertCurrent = cart => {
    if (!matches(cart)) error('Your cart changed. Review it and try checkout again.');
  };
  const priceCart = cart => {
    const items = cart.items.map(item => {
      const q = quote(item.variant_id);
      const rule = window.SBCheckoutSourceRules?.[String(item.variant_id)];
      const custom = Object.hasOwn(item.properties || {}, '_sb_custom_cost');
      let extra = 0, lineTotal = q.price * item.quantity;
      if (custom) {
        if (!rule?.costRule) error('This cost is not supported for the selected package.');
        extra = window.SBCustomCost.quoteSavedCost(item.properties, rule.costRule.units * item.quantity, rule.costRule.feeBasisPoints).total;
        lineTotal += extra;
      }
      if (rule?.legacyCostRule) {
        const r = rule.legacyCostRule;
        lineTotal = window.SBCustomCost.quoteCost(r.unitCostCents, r.units * item.quantity, r.feeBasisPoints).total;
      }
      return { ...item, available: q.available, price: lineTotal / item.quantity, original_price: custom ? q.original_price + extra / item.quantity : q.original_price, final_price: lineTotal / item.quantity, line_price: lineTotal, original_line_price: custom ? q.original_price * item.quantity + extra : rule?.legacyCostRule ? lineTotal : q.original_price * item.quantity, final_line_price: lineTotal };
    });
    return { ...cart, items, currency: 'EUR', item_count: items.reduce((n, i) => n + i.quantity, 0), total_price: items.reduce((n, i) => n + i.final_line_price, 0), attributes: {}, note: '', total_discount: 0 };
  };
  const save = (cart, previous) => {
    if (signature(read()) !== signature(previous)) error('Your cart changed in another tab. Please try again.');
    try { localStorage.setItem(key, JSON.stringify({ ...cart, revision: (previous.revision || 0) + 1 })); }
    catch (_) { error('Your cart could not be saved. Please enable browser storage and try again.'); }
  };
  const lock = action => navigator.locks ? navigator.locks.request(key, action) : action();
  const trackFunnel = async (name, valueCents, currency, items) => {
    // Tracking never blocks a valid cart or changes payment eligibility.
    try {
      const hub = window.ConversionHub || await window.ConversionHubReady;
      const products=(items||[]).map(i=>({id:'starsbooster_'+i.variant_id,quantity:i.quantity,unitPrice:i.final_price/100}));
      if(name==='InitiateCheckout'&&hub?.trackCheckoutHandoff){await Promise.race([hub.trackCheckoutHandoff(valueCents,currency,products),new Promise(resolve=>setTimeout(resolve,1400))]);return;}
      if (hub?.trackMetaFunnel) await Promise.race([hub.trackMetaFunnel(name, valueCents, currency, products), new Promise(resolve => setTimeout(resolve, 1400))]);
    } catch (_) {}
  };
  const makeCart = async cart => {
    await refresh();
    return { priced: priceCart(cart) };
  };
  const get = async () => {
    const cart = read();
    if (!cart.items.length) return priceCart(cart);
    await refresh();
    return priceCart(cart);
  };
  const add = items => lock(async () => {
    const previous = read();
    const form = [...document.querySelectorAll('form')].find(candidate => {
      const source = candidate.querySelector('[data-sb-product-variants]');
      return source && JSON.parse(source.textContent).some(v => String(v.id) === String(items[0]?.id));
    });
    if (!form?.querySelector('[data-sb-b-product]')) error('This selection is unavailable. Please refresh the page.');
    const product = JSON.parse(form?.querySelector('[data-sb-b-product]')?.textContent || '{}');
    const variants = JSON.parse(form?.querySelector('[data-sb-product-variants]')?.textContent || '[]');
    const enriched = items.map(item => {
      if (!Number.isSafeInteger(item.quantity) || item.quantity < 1 || item.selling_plan) error('This selection is unavailable.');
      const variant = variants.find(v => String(v.id) === String(item.id));
      const options = window.SBCheckoutSourceRules?.[item.id]?.options || {};
      const title = variant ? product.title : item.properties['Add-on'] || item.properties['Gig cost'] || item.properties['Priced add-on'];
      return { ...item, variant_id: item.id, key: `${item.id}:${item.properties['_StarsBooster bundle']}`, product_title: title, title, variant_title: variant?.title || title, variant_options: Object.values(options), options_with_values: Object.entries(options).map(([name, value]) => ({ name, value })), handle: product.handle, url: `/products/${encodeURIComponent(product.handle)}?variant=${items[0].id}`, image: product.image, featured_image: { url: product.image }, requires_shipping: false };
    });
    const result = await makeCart({ ...previous, items: [...previous.items, ...enriched] });
    const addedKeys = new Set(enriched.map(item => item.key));
    if (result.priced.items.some(item => addedKeys.has(item.key) && !item.available)) error('This selection is unavailable. Please refresh the page.');
    save(result.priced, previous);
    const addedValue = result.priced.items.filter(item => addedKeys.has(item.key)).reduce((sum, item) => sum + item.final_line_price, 0);
    await trackFunnel('AddToCart', addedValue, result.priced.currency, result.priced.items.filter(item=>addedKeys.has(item.key)));
    return result.priced;
  });
  const update = updates => lock(async () => {
    const previous = read();
    const items = previous.items.map(item => ({ ...item, quantity: Object.hasOwn(updates, item.key) ? Number(updates[item.key]) : item.quantity })).filter(i => i.quantity !== 0);
    if (items.some(i => !Number.isSafeInteger(i.quantity) || i.quantity < 1)) error('Choose a valid quantity.');
    const increased = items.some(i => i.quantity > previous.items.find(p => p.key === i.key).quantity);
    const next = { ...previous, items };
    if (increased) save((await makeCart(next)).priced, previous);
    else save(next, previous);
    const priced = await get();
    const added=[],removed=[];
    for(const old of previous.items){
      const current=priced.items.find(i=>i.key===old.key);
      const delta=(current?.quantity||0)-old.quantity;
      if(delta>0)added.push({...current,quantity:delta});
      if(delta<0){const price=current?.final_price??old.final_price??quote(old.variant_id).price;removed.push({...old,quantity:-delta,final_price:price});}
    }
    for(const [event,changed]of [['AddToCart',added],['RemoveFromCart',removed]])if(changed.length)await trackFunnel(event,changed.reduce((n,i)=>n+i.final_price*i.quantity,0),'EUR',changed);
    return priced;
  });
  const open = cart => lock(async () => {
    assertCurrent(cart);
    await refresh();
    assertCurrent(cart);
    const priced = priceCart(read());
    if (priced.items.some(item => !item.available)) error('A selected package or add-on is unavailable. Please remove or change it.');
    if (cart.currency !== priced.currency || cart.total_price !== priced.total_price) error('Your cart price changed. Review it and try checkout again.');
    await trackFunnel('InitiateCheckout', priced.total_price, priced.currency, priced.items);
    assertCurrent(priced);
    return window.SBCrossStoreCheckout.open(priced);
  });
  window.SBStoreB = { refresh, quote, get, add, update, open, matches, key, request: async (url, options = {}) => {
    let body;
    try {
      const path = new URL(url, window.location.origin).pathname;
      const input = options.body ? JSON.parse(options.body) : {};
      body = /\/cart\/add\.js$/.test(path) ? await add(input.items) : /\/cart\/update\.js$/.test(path) ? await update(input.updates) : await get();
      return { ok: true, json: async () => body };
    } catch (e) { return { ok: false, json: async () => ({ description: e.message }) }; }
  } };
})();
